// extracted by mini-css-extract-plugin
export var childrenContainer = "_bl-0";
export var virtualScrollArea = "_bl-1";